import React, { useState } from 'react';
import { Alert, Button, Form, Input, Space, Typography, message } from 'antd';
import i18n from '~/i18n';
import { fetchLogin } from './api';
import { useSaveLogin } from '~/App/store/auth';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  // Error message.
  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const saveLogin = useSaveLogin();
  const navigate = useNavigate();

  const handleLogin = async (values: { username: string; pin: string }) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await fetchLogin(values);
      saveLogin(data);
      navigate('/');
    } catch (e: any) {
      messageApi.open({ type: 'error', content: e.message });
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 700,
        boxSizing: 'border-box',
        padding: 20,
      }}
    >
      {contextHolder}
      <Typography.Title level={3} style={{ textAlign: 'center' }}>
        Dashboard
      </Typography.Title>
      <br />
      {error ? (
        <>
          <Alert message={error} type="error" showIcon />
          <br />
        </>
      ) : null}
      <Form
        name="login"
        layout="vertical"
        onFinish={handleLogin}
        autoComplete="off"
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="PIN"
          name="pin"
          rules={[{ required: true, message: 'Please input your PIN!' }]}
        >
          <Input.Password />
        </Form.Item>
        <br />
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            Login
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
